import ApiService from "@/_services/api.service";
import { ApprovedVersion } from "@/models/securite/approvedVersion/ApprovedVersion";
import { ref } from 'vue';
import swal from "@/_helpers/swal";
import {IPostApprovedVersion} from "@/models/ApprovedVersion/IApprovedVersion";

export async function createApprovedVersion(data: IPostApprovedVersion) {
    try {
        await ApiService.post("approved_versions", {
            version: data.version,
            os: data.os,
            domain: data.domain,
        }).then((apiResponse) => {
            return apiResponse;
        });
    } catch (error) {
        return error;
    }
}

export async function fetchApprovedVersions(
    itemsPerPage: number,
    page: number,
    globalSearch?: null|string,
    sort?: { fieldLabel: string; fieldValue: string; },
    filters?: Record<string, string | number>
): Promise<[boolean, number, ApprovedVersion[]]> {
    const isLoading = ref<boolean>(true);
    const totalRecords = ref<number>(0);
    const tableData = ref<Array<ApprovedVersion>>([]);
    let params = {
        itemsPerPage: itemsPerPage,
        page: page,
        search: globalSearch,
    };

    if (isNotEmpty(globalSearch)) {
        params = { ...params, search: globalSearch?.trim() };
    }

    if (sort !== undefined) {
        const { fieldValue, fieldLabel } = sort;
        params = {...params, [fieldLabel]: fieldValue};
    }

    if (filters) {
        Object.entries(filters)
            .filter(([key, value]) => isNotEmpty(value))
            .forEach(([key, value]) => {
                params[key] = value;
            });
    }
    
    try {
        const { data } = await ApiService.get(`approved_versions`, {
            headers: { Accept: 'application/ld+json' },
            params: params
        });
        totalRecords.value = data.data['hydra:totalItems'];
        tableData.value = data.data['hydra:member'];
    } catch (error) {
        swal.error('Une erreur est survenue au chargement des versions');
        console.error('Error fetching approved versions:', error);
    }
    isLoading.value = false;
    
    return [isLoading.value, totalRecords.value, tableData.value];
}

export const toggleApprovedStatus = async (approvedVersion: ApprovedVersion): Promise<boolean> => {
    try {
        await ApiService.patchWithoutSlug(`/approved_versions/${approvedVersion.uuid}`, {})
            .then(() => {
                return true;
            });
        
        return true;
    } catch (error) {
        return false;
    }
}

export const deleteApprovedVersion = async (approvedVersion: ApprovedVersion): Promise<boolean> => {
    try {
        await ApiService.delete(`/approved_versions/${approvedVersion.uuid}`).then(() => {
            return true;
        });
        
        return true;
    } catch (error) {
        return false;
    }
}

const isNotEmpty = (value: any) => {
    return value !== null && value !== undefined && (typeof value !== 'string' || value.trim() !== '');
}

export const ApprovedVersionService = {
    createApprovedVersion,
    fetchApprovedVersions,
    toggleApprovedStatus,
    deleteApprovedVersion
}